import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const EmailVerification = () => {
    const [status, setStatus] = useState('verifying');
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const verifyEmail = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/verify-email`, { token });
                setStatus('success');
                setTimeout(() => navigate('/login'), 3000);
            } catch (error) {
                setStatus('error');
            }
        };

        if (token) {
            verifyEmail();
        }
    }, [token, navigate]);

    const renderContent = () => {
        switch (status) {
            case 'verifying':
                return (
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
                        <p className="mt-4">Verifying your email...</p>
                    </div>
                );
            case 'success':
                return (
                    <div className="text-center text-green-600">
                        <svg className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                        </svg>
                        <p className="mt-4">Email verified successfully! Redirecting to login...</p>
                    </div>
                );
            case 'error':
                return (
                    <div className="text-center text-red-600">
                        <svg className="h-12 w-12 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                        <p className="mt-4">Failed to verify email. The link may be expired or invalid.</p>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Email Verification
                    </h2>
                </div>
                <div className="mt-8">
                    {renderContent()}
                </div>
            </div>
        </div>
    );
};

export default EmailVerification; 